<h2 style="display: flex;
  align-items: center;
  justify-content: center;
  color: gold;
  margin-bottom: -3px;">Form fields have been erased</h2>